import Decimal from 'decimal.js';

/**
 * §7.10.1 — Para aritmetiği.
 *
 * **Asla `float`/`double` kullanılmaz.** Fiyat çözümü bölme içerir
 * (`P = C·(1+m)/K`) ve IEEE-754 hatası burada birikir; 200.000 üründe
 * kuruş farkları gerçek para kaybına dönüşür.
 *
 * Yuvarlama politikası: ara hesaplarda **yuvarlama yok**. Yuvarlama yalnızca
 * `roundPrice()` içinde ve **her zaman yukarı** yapılır (§8.7).
 */

// 40 anlamlı basamak: 80 iterasyonluk bisection'da bile birikimli hata olmaz.
Decimal.set({ precision: 40, rounding: Decimal.ROUND_HALF_UP, toExpNeg: -30, toExpPos: 30 });

export { Decimal };

/** Bir sayıyı/dizeyi Decimal'e çevirir. `null`/`undefined` → varsayılan. */
export function dec(value: Decimal.Value | null | undefined, fallback: Decimal.Value = 0): Decimal {
  if (value === null || value === undefined) return new Decimal(fallback);
  return new Decimal(value);
}

/** Yüzde değerini orana çevirir: 15 → 0.15 */
export function pct(value: Decimal.Value | null | undefined): Decimal {
  return dec(value).div(100);
}

/** USD: 2 ondalık, yukarı yuvarlama (maliyet eksik hesaplanmasın). */
export function usd(value: Decimal.Value): Decimal {
  return dec(value).toDecimalPlaces(2, Decimal.ROUND_UP);
}

/** JPY: kuruşsuz. Maliyet tarafında yukarı, böylece kâr olduğundan az görünür. */
export function jpyCeil(value: Decimal.Value): number {
  return dec(value).toDecimalPlaces(0, Decimal.ROUND_UP).toNumber();
}

/** JPY tam sayıya en yakın yuvarlama — yalnızca gösterim/karşılaştırma için. */
export function jpyRound(value: Decimal.Value): number {
  return dec(value).toDecimalPlaces(0, Decimal.ROUND_HALF_UP).toNumber();
}

export function isFiniteDecimal(value: Decimal): boolean {
  return value.isFinite() && !value.isNaN();
}
